export const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem(`${process.env.REACT_APP_PREFIX}.user`))
}

export const userEndPoint = () => {
  return `/users/${getCurrentUser().id}`
}
